<!--
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-05-25 19:05:44
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-04-29 10:57:41
 * @FilePath: \jyrg-web\src\components\pc\Footer\index.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <footer>
      <div class="footer">
        <div class="title">健康游戏忠告</div>
        <p>{{ footer.hintText }}</p>
        <div class="link">
          <!-- <a @click="footerSkip(footer.familySafety)">{{
            footer.familySafety.title
          }}</a>
          | -->
          <a @click="footerSkip(footer.service)">{{ footer.service.title }}</a>
          |
          <a @click="footerSkip(footer.privacyPolicy)">{{
            footer.privacyPolicy.title
          }}</a>
          |
          <a @click="footerSkip(footer.userAgreement)">{{
            footer.userAgreement.title
          }}</a>
        </div>
        <div class="mes">
          <p v-if="false">国新出审【2022】网络游戏出版物品</p>
          <p v-if="false">987-498-09911-2</p>
          <img
            v-if="false"
            class="police"
            src="../../../assets/image/pc/police.png"
            alt=""
          />
          <p v-if="false">京公网安备11011502037511号</p>
          <a href="https://beian.miit.gov.cn"  target="_Blank">吉ICP备2024012572号</a>
          <!-- <p>Copyright © 保定极乐游网络科技有限公司版权所有</p> -->
          <p v-if="false">本游戏适合16岁以上玩家</p>
          <!-- <p class="clickP" @click="goToCSIP()">{{ footer.recordsText1 }}</p>
          <p>{{ footer.recordsText2 }}</p> -->
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    footer() {
      return this.$config.footer;
    },
  },
  methods: {
    async footerSkip(item) {
      let { id, title, type } = item;
      this.$router.push({ path: "/detail", query: { id, title, type } });
    },
    goToCSIP() {
      window.open("https://beian.miit.gov.cn/");
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  align-items: center;
  min-width: 1920px;
  height: 255px;
  color: #000;
  font-size: 12px;
  .title {
    font-size: 30px;
  }
  p {
    font-size: 20px;
  }
  .link {
    a {
      font-size: 20px;
      color: #000;
      margin: 0 10px;
      position: relative;
      text-decoration: underline;
      cursor: pointer;
      z-index: 9999;
    }
  }
  .mes {
    width: 1277px;
    height: 60px;
    display: flex;
    justify-content: center;

    align-items: center;
    flex-wrap: wrap;
    font-size: 20px;
    p {
      margin-right: 12px;
    }
    a {
      cursor: pointer;
      color: #000;
    }
    a:hover {
      color: #000;
      text-decoration: underline;
    }
    a:active {
      color: #000;
    }

    .police {
      width: 20px;
      height: 20px;
    }
  }
}
</style>
